import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ITreatyState } from '../../store/reducers/treaty.reducer';
import {select, Store} from '@ngrx/store';
import {BreadcrumbModel} from "@shared/models/breadcrumb.model";
import {Configuration} from "@shared/models/configuration";
import {InvalidateSubject} from "@shared/helpers/invalidate.subject";
import {getQueryResponse} from "@shared/store/selectors/query.selector";
import {QueryProvider} from "@shared/queries/query-provider";
import {IQueryState} from "@shared/store/reducers/query.reducer";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {Country, FileInfo} from "../../models/treaty.models";
import {TreatyApiService} from "../../services/treaty.service";


@Component({
    standalone: false,
    selector: 'particle-treaty-status',
  templateUrl: './treaty-status.component.html',
  styleUrls: ['./treaty-status.component.scss']
})

export class TreatyStatusComponent implements OnInit {

  ngUnsubscribe$ = new Subject<void>();
  sourceKey: string;
  invalidateSubject: InvalidateSubject;
  breadcrumbs: BreadcrumbModel[];
  breadcrumbs$: any;
  breadcrumbKey: string;
  country1: Country;
  country2: Country;
  parentSourceKey: string;
  firstCountrySourceKey: string;
  secondCountrySourceKey: string;
  id: string;
  id1: string;
  id2: string;

  @Input() info: {country1: Country, country2: Country};
  @Input() type: string;
  @Input() countryCode1: string;
  @Input() countryCode2: string;


  private config: any;
  constructor(private store: Store<ITreatyState>,
              protected activatedRoute: ActivatedRoute,
              private queryState: Store<IQueryState>,
              private router: Router,
              private treatyService: TreatyApiService) {


  }

  ngOnInit(){
    console.log("Received:::", this.info);
    console.log(":::", this.info.country1.name);
    if(this.type == 'Dynamic') {
      this.parentSourceKey = 'Treaty-Parent-Status';
    }
    else {
      this.parentSourceKey = 'BEPS-CbC-Exchange-Status';
    }
    this.firstCountrySourceKey = 'Treaty-Status';
    this.secondCountrySourceKey = 'Treaty-Second-Country-Status';

    this.country1 = this.info.country1;
    this.country2 = this.info.country2;
    this.id = `${this.countryCode1}-${this.countryCode2}`;
    this.id1 = this.countryCode1;
    this.id2 = this.countryCode2;
  }


  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

}

